import _ from 'lodash';
import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Button,
  HelpBlock,
  InputText,
  SuccessMessage,
  selectorProps,
} from '../../common/form';
import useStore from './store-hook';
import {
  createFundCategory,
  updateFundCategory,
  deleteFundCategory,
} from '../../../../services/lwadmin/data-provider/fund-category-service';

const SSuccessMessage = styled(SuccessMessage)`
  margin-bottom: 0;
`;

const Form = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 0;

  & > .category {
    width: 45%;
  }

  & > .asset-class {
    width: 30%;

    [class*="control"] {
      & > div:first-child {
        margin-top: 0;
      }
    }
  }

  & > .action {
    width: 25%;
    padding-left: 20px;
  }
`;

const SInputText = styled(InputText)`
  width: 90%;
`;

const SButton = styled(Button)`
  margin-top: 0;
  margin-right: 10px;
  padding: 0 10px;
`;

export default function Category(props) {
  const assetClasses = useStore(state => state.assetClasses);
  const [saving, setSaving] = React.useState(false);
  const [deleted, setDeleted] = React.useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = React.useState(false);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [category, setCategory] = React.useState(_.get(props, 'category', {}));
  const { id, name, fundAssetClassId } = category;
  const assetClassIdString = fundAssetClassId === null ? null : fundAssetClassId.toString();
  const selectedAssetClass = _.find(assetClasses, { value: assetClassIdString });

  const onNameChange = e => {
    e && e.preventDefault();
    const newName = _.get(e, 'target.value', '');
    setCategory({ ...category, name: newName });
  };

  const onAssetClassChange = selected => {
    setCategory({ ...category, fundAssetClassId: selected.value });
  };

  const saveCategory = e => {
    e && e.preventDefault();
    setSaving(true);

    const payload = { name, fund_asset_class_id: fundAssetClassId };
    const createOrUpdate = id ? updateFundCategory(id, payload) : createFundCategory(payload);

    createOrUpdate.then(resp => {
      setSaving(false);
      setError(null);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);

      const createdId = _.get(resp, 'data.id');
      if (createdId) {
        setCategory({ ...category, id: createdId });
      }
    }).catch(errorResp => {
      setSaving(false);
      setShowSuccess(false);
      setError(_.get(errorResp, 'response.data'));
    });
  };

  const deleteCategory = e => {
    e && e.preventDefault();

    deleteFundCategory(id).then(() => setDeleted(true)).catch(errorResp => setError(_.get(errorResp, 'response.data')));
  };

  if (deleted) {
    return null;
  }

  return (
    <>
      {showSuccess && <SSuccessMessage>Category successfully saved</SSuccessMessage>}
      {error && <HelpBlock>{error.name}</HelpBlock>}
      <Form>
        <span className="category">
          <SInputText
            id={name}
            type="text"
            name="name"
            value={name}
            placeholder="Category name"
            onChange={onNameChange}
          />
        </span>
        <span className="asset-class">
          <Select
            {...selectorProps}
            placeholder="Select asset class"
            value={selectedAssetClass}
            options={assetClasses}
            onChange={onAssetClassChange}
          />
        </span>
        <span className="action">
          {!showDeleteConfirmation && (
            <SButton className="btn btn-default" onClick={saveCategory} disabled={saving}>
              {saving ? 'Saving' : 'Save'}
            </SButton>
          )}
          {id && !showDeleteConfirmation && (
            <SButton className="btn btn-danger" onClick={() => setShowDeleteConfirmation(true)}>
              Delete
            </SButton>
          )}
          {showDeleteConfirmation && (
            <>
              <SButton className="btn btn-danger" onClick={deleteCategory}>
                Confirm
              </SButton>
              <SButton className="btn btn-default" onClick={() => setShowDeleteConfirmation(false)}>
                Cancel
              </SButton>
            </>
          )}
        </span>
      </Form>
    </>
  );
}

Category.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    fundAssetClassId: PropTypes.number,
  }).isRequired,
};
